import {PageTitle} from '../../../../_designereyes/layout/core'
import {AmazonHelium10UploaderPage} from './AmazonHelium10UploaderPage'

const breadcrumbs = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: ' / ',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AmazonHelium10Uploader = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Helium 10 Sales Uploader</PageTitle>
      <AmazonHelium10UploaderPage />
    </>
  )
}

export default AmazonHelium10Uploader 